import { GameSceneAbstract } from "@/scenes/game-scene-abstract";
import game from '@/model/game';
import { activateScene } from '@/scenes';
import { DebugOverlay } from '@/ui/debug-overlay';
import { Gui3D } from '@/ui/gui';
import { WIDTH, HEIGHT } from '@/constants';
import { Engine3D } from '@/components/engine-3d';

const SPEED = 20,
    CHART_HEIGHT = HEIGHT, CHART_WIDTH = WIDTH, JUDGEMENT_LINE_POS_PX = 100;

export class GameScene3D extends GameSceneAbstract {
    constructor() {
        super('game-3d');
    }

    initJudgementLine() {
    }

    update() {
        this.engine.update(this.audio.currentTime);
        if (this.audio.currentTime >= this.audio.duration && game.isPlaying) {
            game.isPlaying = false;
            this.showResultsScreen();
        }
    }

    async loadMxl(pathToFile) {
        return super.loadMxl(pathToFile)
            .then(async ({
                measures, attributes,
                beats, beatType,
                divisionsPerQuarterNote,
                key, notes, meta, boundaries }) => {
                const totalLengthBeats = Math.round(this.audio.duration / 60 * game.bpm);
                const totalLengthPx = SPEED * totalLengthBeats;
                const pxPerSecond = totalLengthPx / this.audio.duration;
                const engine = new Engine3D({
                    chartHeight: CHART_HEIGHT,
                    chartWidth: CHART_WIDTH,
                    judgementLinePositionPx: JUDGEMENT_LINE_POS_PX,
                    pxPerSecond,
                    pianoKeyWidth: this.pianoKeyWidth,
                    notes,
                    totalLengthBeats,
                    duration: this.audio.duration,
                    bpm: game.bpm,
                    boundaries
                });
                this.engine = engine;
                engine.position.set(WIDTH / 2, HEIGHT / 2);
                this.notesToUpdate = this.engine.noteGems;
                this.addChild(engine);
                this.ui = new Gui3D({
                    boundaries,
                    pianoWidth: CHART_WIDTH,
                    pianoKeyWidth: this.pianoKeyWidth,
                    pianoKeyBorder: 2,
                    pianoHighlightHeight: HEIGHT
                });
                this.initJudgementLine();
                this.addChild(this.ui);
                this.addChild(new DebugOverlay());
                this.ui.setProgress(1);
                return Promise.resolve();
            }).catch(e => {
                console.error(e);
                activateScene('error', e);
            });
    }

    stopAndCleanUp() {
        super.stopAndCleanUp();
        this.engine.cleanup();
    }
}